import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
  infoText: {
    paddingTop: theme.spacing(2),
  },
}));
